import type SharedChart from '../../../models/SharedChartModel';
import { requestAndParse, requestSuccessful } from '../request';

const getSharedCharts = async (friendId: number) => {
    const route = 'charts/get-shared-charts';
    const payload = { friendId };

    const response = await requestAndParse(route, payload, 'GET');

    const sharedCharts = (response.body?.sharedCharts ?? []) as SharedChart[];
    const hasInstructorNotesPermission = (response.body
        ?.instructorNotesPermission ?? false) as boolean;

    return {
        sharedCharts,
        hasInstructorNotesPermission,
        success: requestSuccessful(response),
        error: response.body?.message as string | undefined,
    };
};

export default getSharedCharts;
